// ------------ Utility Functions to Update Measurement Cycles --------------------------
function isCompatible(element_type, element_type_next){
    let is_compatible = true;     
    let compatible_types = []
    if (element_type === 'Process'){
        compatible_types = ['Process', 'Measurement'];
    }
    if (element_type === 'Measurement' || element_type === 'GoNoGo'){
        compatible_types = ['Measurement', 'GoNoGo'];
    }
    if(!compatible_types.includes(element_type_next) ) {
        is_compatible = false
    }
    return is_compatible;
}


function isValidCycle(cycle, elements){
    let is_valid = true;
    // invalid if less then 2 elements
    if (cycle.length < 2) { return false; }
    // first element is a valid cycle needs to be a process
    if (cycle.length > 0) { 
        let element_id = cycle[0]
        let element_type = elements[element_id].type
        if (element_type !== 'Process'){ is_valid = false }
    }
    for(let i=0; i<cycle.length-1; i++)
       {
        let element_id = cycle[i];
        let element_id_next = cycle[i+1];
        let element_type = elements[element_id].type
        let element_type_next = elements[element_id_next].type
        if(!isCompatible(element_type, element_type_next)) { is_valid = false }
    }
    let last_element_id = cycle[cycle.length-1];
    let element_type = elements[last_element_id].type
    if(element_type !== 'Measurement' && element_type !== 'GoNoGo' ) { is_valid = false }
    return is_valid;
}

function isPartOfCycle(cycles, cycle_id, elem_id){
    if ( cycles.length === 0 ) {
        return false
    }
    else {
        return cycles[cycle_id].cycle_elements.includes(elem_id);
    }
}

export function updateCycles_onAddElement(elements, cycles, cycle_template){
    let createdCycles = []
    let cycle_id = 0
    let new_cycle_elements = [];
    if (cycles.length > 0) { createdCycles.push(cycles[0]); }
    for(let elem_id=0; elem_id<elements.length; elem_id++){
        // if the element is not part of an existing cycle
        if( !isPartOfCycle(cycles, cycle_id, elem_id) ) {
            // if the new elemetn is compatible to an existing adjasent cycle -> add to that cycle
            if ( elem_id > 0) {
                let prev_element_type = elements[elem_id-1].type
                let element_type = elements[elem_id].type
                // if previous element is in a cycle
                if (isPartOfCycle(cycles, cycle_id, elem_id-1)){
                    if( isCompatible(prev_element_type, element_type) ) {
                        // if the new element is compatible with that existing cycle
                        cycles[cycle_id].cycle_elements.push(elem_id)
                        continue;
                    }
                }
            }
            // if we attempt to start a new cycle without any elements
            if ( new_cycle_elements.length===0 ) { new_cycle_elements.push(elem_id); }  // DO NOT DO THIS AS DEFAUTL
            else {
                // add element if compatible with previous element
                let prev_element_type = elements[elem_id-1].type
                let element_type = elements[elem_id].type
                if ( isCompatible(prev_element_type, element_type) ){
                    // if prev_elements is in a cycle -> the add the element to that cycle 
                    new_cycle_elements.push(elem_id);
                    // if we reach last element -> create cycle
                    if(elem_id === elements.length-1) {
                        if( isValidCycle(new_cycle_elements, elements) ) { 
                            let new_cycle = {cycletime_min: '', 
                                             cycletime_max: '', 
                                             cycletime_unit: '', 
                                             runparallel_min: '', 
                                             runparallel_max: '', 
                                             cycle_elements: new_cycle_elements};
                                             createdCycles.push(new_cycle);
                        }
                    }
                }
                // if element is incompatible
                else {
                    // if 'new_cycle_elements' form a valid cycle -> create this old cycle and start a new cycle
                    if( isValidCycle(new_cycle_elements, elements) ) { 
                        let new_cycle = {cycletime_min: '', 
                                         cycletime_max: '', 
                                         cycletime_unit: '', 
                                         runparallel_min: '', 
                                         runparallel_max: '', 
                                         cycle_elements: new_cycle_elements};
                        createdCycles.push(new_cycle);
                        new_cycle_elements = [elem_id];
                    }
                    // drop current cycle and start over (starting from this element)
                    else { new_cycle_elements = [elem_id]; }
                }
            }
        }
        else {    
            // if we reach last element in the existing cycle then move to the next existing cycle
            if (elem_id === Math.max(...cycles[cycle_id].cycle_elements)){
                // if not last cycle
                if (cycle_id < cycles.length-1) { cycle_id += 1; }
            }
            // if we reach an existing cycle 
            else if (elem_id === Math.min(...cycles[cycle_id].cycle_elements) && elem_id !==0 ){
                let prev_element_type = elements[elem_id-1].type
                let element_type = elements[elem_id].type
                // IF 'new_cycle_elements' form a valid cycle -> then CREATE_NEW_CYCLE
                if( isValidCycle(new_cycle_elements, elements) ) { 
                    let new_cycle = JSON.parse(JSON.stringify(cycle_template));
                    new_cycle.cycle_elements = new_cycle_elements;
                    createdCycles.push(new_cycle)
                    new_cycle_elements = [];
                }
                // IF 'new_cycle_elements' is compatible with cycle[cycle_id] -> Add what we have to the cycle[cycle_id]
                else if ( isCompatible(prev_element_type, element_type) ){
                    cycles[cycle_id] = [...new_cycle_elements, ...cycles[cycle_id].cycle_elements]
                    new_cycle_elements = []
                }
                else {
                // IF NEITHER -> drop what we have
                    new_cycle_elements = []
                    // cycle_id === 0 was alreay added
                    if(cycle_id!==0) { createdCycles.push(cycles[cycle_id]) }
                }
            }
        }
    }
    return createdCycles;
}


function partofCylce(elem_id_removed, cycles){
    // returns -1 if removed element was not part of any cycle
    if (cycles.lenght === 0) {return -1;}
    for (let cycle_id=0; cycle_id< cycles.length; cycle_id++){
        if (isPartOfCycle(cycles, cycle_id, elem_id_removed)) {
            return cycle_id;
        }
    }
    return -1;
}

function updateCycleIds(cycle, elem_id_removed) {
    for (let i = 0; i < cycle.cycle_elements.length; i++) {
        if (cycle.cycle_elements[i] > elem_id_removed) {
            cycle.cycle_elements[i] -= 1;
        }
    }
    return cycle;
}


function shiftCycleIds(cycle, shift) {
    for (let i = 0; i < cycle.cycle_elements.length; i++) {
        cycle.cycle_elements[i] += shift;
    }
    return cycle;
}


function findLeftCycle(all_cycles, elem_id) {
    let cycleLeft = -1;
    for (let i=0; i<all_cycles.length; i++) {
        let max = Math.max(...all_cycles[i].cycle_elements);
        if (max >= cycleLeft && max < elem_id) { cycleLeft = i; }
    }
    return cycleLeft;
}

function findRightCycle(all_cycles, elem_id) {
    let cycleRight = -1;
    for (let i=0; i<all_cycles.length; i++) {
        let min = Math.min(...all_cycles[i].cycle_elements);
        if (min > elem_id) { return i; }
    }
    return cycleRight;
}

function handleCycles(elements, cycle_left, cycle_right, cycle_template){
    let cycle_l = [];
    let cycle_r = [];
    let new_cycles = [];
    let all_cycles = []
    if (cycle_left) { cycle_l = [cycle_left]; }
    if (cycle_right) { cycle_r = [cycle_right]; }

    let build_new_cycle_elements = []

    for (let elem_id=0; elem_id<elements.length; elem_id++)
    {
        let merged = false;
        if ( !isPartOfCycle(cycle_l, 0, elem_id) && !isPartOfCycle(cycle_r, 0, elem_id) )  {
            // if cycle_l not [] and if previous element is part of cycle_l
            if ( cycle_l.length > 0 && isPartOfCycle(cycle_l, 0, elem_id-1) ) {
                if ( isCompatible(elements[elem_id-1].type, elements[elem_id].type) ) { 
                    cycle_l[0].cycle_elements.push(elem_id);
                    merged=true;
                }
            }
            // if: elem_id is not last element and  next_elem is in cycle_r[0]  
            if ( elem_id < elements.length -1 && cycle_r.length > 0 && isPartOfCycle(cycle_r, 0, elem_id+1) ) {
                if ( isCompatible(elements[elem_id].type, elements[elem_id+1].type) ) { 
                    cycle_r[0].cycle_elements = [elem_id, ...cycle_r[0].cycle_elements];
                    merged=true;
                }
            }

            // if element cannot be merged with cylce_l and cannot be merged with cycle_r; try to build a cycle with the 'lose' elements.
            if(!merged){
            // if element is compatible with previous 
                if(build_new_cycle_elements.length !== 0){
                    if( isCompatible(elements[elem_id-1].type, elements[elem_id].type) ) {
                        build_new_cycle_elements.push(elem_id);
                    }
                    // if not compatible; see if build_cycle is a valid cycle -> if yes then build it, if not then drop it
                    else{
                        if( isValidCycle(build_new_cycle_elements, elements) ) { 
                            let new_cycle = JSON.parse(JSON.stringify(cycle_template));
                            new_cycle.cycle_elements = build_new_cycle_elements;
                            new_cycles.push(new_cycle);
                            build_new_cycle_elements=[elem_id];
                        }
                        else { build_new_cycle_elements=[elem_id];}
                    }
                }
                // If first element then start build a cycle
                else{
                    build_new_cycle_elements.push(elem_id);
                }
            }
        }
        // If we hit last element, we need to create a cycle with 'build_new_cycle_elements' - if it is a valid cycle. 
        if( elem_id === elements.length -1 && isValidCycle(build_new_cycle_elements, elements) ) { 
            let new_cycle = JSON.parse(JSON.stringify(cycle_template));
            new_cycle.cycle_elements = build_new_cycle_elements;
            new_cycles.push(new_cycle);
        }
    }
    if (cycle_l) { all_cycles = [...all_cycles, ...cycle_l]; }
    if (new_cycles.length>0) { all_cycles = [...all_cycles, ...new_cycles]; }
    if (cycle_r) { all_cycles = [...all_cycles, ...cycle_r]; }
    return all_cycles;
}

function rebuildCycles(all_cycles, elements, elem_id1, elem_id2, cycle_template){
    let updated_cycles = []
    let cycle_id_left = findLeftCycle (all_cycles, elem_id1);
    let cycle_left = null;
    let cycle_right = null;
    let left_id_min = 0;
    let cycle_id_right = findRightCycle (all_cycles, elem_id2);
    let right_id_max = elements.length -1 
    if (cycle_id_left !== -1) { 
        left_id_min = Math.min(...all_cycles[cycle_id_left].cycle_elements);
        cycle_left = shiftCycleIds(all_cycles[cycle_id_left], -left_id_min)
    }
    if (cycle_id_right !== -1) { 
        right_id_max = Math.max(...all_cycles[cycle_id_right].cycle_elements);
        cycle_right = shiftCycleIds(all_cycles[cycle_id_right], -left_id_min)
    }

    // find cycle that is right from the removed element 
    let elements_tmp = elements.slice(left_id_min, right_id_max + 1);
    let new_cycles = handleCycles(elements_tmp, cycle_left, cycle_right, cycle_template);
    for (let i=0; i<new_cycles.length; i++) {
        new_cycles[i]=shiftCycleIds(new_cycles[i], left_id_min);
    }
    // collect and return all cycles
    for(let i=0; i<cycle_id_left; i++) {
        updated_cycles.push(all_cycles[i]);
    }
    for(let i=0; i<new_cycles.length; i++) {
        updated_cycles.push(new_cycles[i]);
    }
    if(cycle_id_right !== -1) {
        for (let i=cycle_id_right+1; i< all_cycles.length; i++ ) {
            updated_cycles.push(all_cycles[i]);
        }
    }
    return updated_cycles;
}

export function updateCycles_onDeleteElement(elements, cycles, elem_id_removed, cycle_template){
    let cycle_id = partofCylce(elem_id_removed, cycles);
    let updated_cycles = []
    // if deleted element was not part of a cycle
    if ( cycle_id === -1) {
        // create a deep copy
        let all_cycles =  JSON.parse(JSON.stringify(cycles));
        // update element ids of each cycle for elements with id > elem_id_removed
        for (let i=0; i<all_cycles.length; i++) { all_cycles[i] = updateCycleIds(all_cycles[i], elem_id_removed, elem_id_removed); }
        return rebuildCycles (all_cycles, elements, elem_id_removed, cycle_template);
    }
    // if deleted element was part of a cycle and the cycle remains valid 
    if ( cycle_id !== -1) {
        let all_cycles =  JSON.parse(JSON.stringify(cycles));
        // remove element from cycle
        all_cycles[cycle_id].cycle_elements = all_cycles[cycle_id].cycle_elements.filter(item => item !== elem_id_removed);
        // update element ids of each cycle for elements with id > elem_id_removed
        for (let i=0; i<all_cycles.length; i++) { all_cycles[i] = updateCycleIds(all_cycles[i], elem_id_removed, elem_id_removed); }
        if (isValidCycle(all_cycles[cycle_id].cycle_elements, elements)) {
            return all_cycles;
        }
        // if updated cycle becomes invalid
        else {
            // drop cycle with cycle_id
            all_cycles = all_cycles.filter((item, index) => index !== cycle_id);
            return rebuildCycles (all_cycles, elements, elem_id_removed, elem_id_removed, cycle_template);
        }        
    }
    return updated_cycles;
}


export function updateCycles_onMoveElement(elements, cycles, elem_id1, elem_id2, cycle_template){
    // Case 1: elem_id1 and elem_id2 are in the same cycle 
    // -> test if cycle stays intact 
    // -> if not -> call rebuild cycle
    /// Case 2: elem_id1 or elem_id2 or both are not in a cycle -> destroy respective cycle(s) (if applicable) -> rebuild
    let all_cycles =  JSON.parse(JSON.stringify(cycles));
    let cycle_id1 = partofCylce(elem_id1, cycles);
    let cycle_id2 = partofCylce(elem_id2, cycles);
    if (cycle_id1 === cycle_id2 && cycle_id1 !== -1){
        if( isValidCycle(cycles[cycle_id1].cycle_elements, elements ) ){
            return all_cycles;
        }
        else {
            return rebuildCycles (all_cycles, elements, elem_id1, elem_id2, cycle_template)
        }
    }
    else{
        return rebuildCycles (all_cycles, elements, elem_id1, elem_id2, cycle_template);
    }
}
